module.exports = __webpack_public_path__ + "static/birdo-3a25c8b688d3939ee934af34bcdc596e.jpg";